import { useState, useRef } from "react";
import { SidebarWrapper } from "./styled";
import { Box, LazyImage, SpanStyled } from "../Styled/Elements";
import { LogoAr, LogoEn, SearchIcon } from "../Styled/AllImages";
import FloatingInput from "../Styled/inputFields/FloatingInput";
import { useTranslation } from "react-i18next";
import { CiCircleCheck } from "react-icons/ci";
import { Link } from "react-router-dom";

const WorkshopSidebar = ({
  data,
  selectedTutorial,
  onSelect,
  sidebarStatus,
  setSidebarStatus,
  participant,
}) => {
  const { t, i18n: {language} } = useTranslation();
  const sidebarRef = useRef();
  const [searchQuery, setSearchQuery] = useState("");

  // Calculate allowed videos
  const watchedCount = participant
    ? Number(participant.watched_videos_counter || 0)
    : 0;

  const filteredData = data?.filter((item) =>
    item?.title?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <SidebarWrapper
      className={`SideBar ${sidebarStatus ? "open" : "close"}`}
      ref={sidebarRef}
    >
      <Box className="text-center">
        <Box className="logo-container d-flex justify-content-between align-items-center">
          <Link to={"/"}>
            <LazyImage src={language === "en" ? LogoEn : LogoAr} />
          </Link>
        </Box>
        <Box className="sidebar-list custom-scroll">
          <Box className="p-3">
            <FloatingInput
              type="input"
              fieldType="text"
              name="search"
              placeholder={t("search")}
              icon={SearchIcon}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </Box>
          <ul className="list-unstyled mb-0 pt-3">
            {filteredData?.map((item, key) => {
              const active = selectedTutorial?.id === item?.id ? "active" : "";
              const isAllowed = key <= watchedCount;
              const isWatched = key < watchedCount;

              return (
                <li key={item?.id} className="mb-2">
                  <Box
                    className={`
                      text-decoration-none sidebar-item d-flex align-items-start gap-2
                      ${active}
                      ${
                        isAllowed ? "cursor-pointer" : "opacity-50 pointer-none"
                      }
                    `}
                    onClick={() => {
                      if (!isAllowed) return;
                      onSelect(item);
                      setSidebarStatus(false);
                    }}
                  >
                    {/* Green Tick for Watched */}
                    {isWatched && (
                      <span style={{ width: "18px", height: "18px" }}>
                        <CiCircleCheck
                          size={18}
                          strokeWidth={1}
                          color="#38D200"
                        />
                      </span>
                    )}
                    <SpanStyled
                      className="text-capitalize d-flex"
                      style={{ textAlign: "start" }}
                    >
                      {item?.title}
                    </SpanStyled>
                  </Box>
                </li>
              );
            })}
          </ul>
        </Box>
      </Box>
    </SidebarWrapper>
  );
};

export default WorkshopSidebar;
